import React from 'react';

import { getRewrittenUrl } from '../../../../../analytics-library/getRewrittenUrl';
import { ActionType } from '../../../../../sharedModules/getActionType';
import { LegacyActionEvent } from '../../../../../types/LegacyActionEvent';
import type { SeasonalEventMerchant } from '../../../../types/SeasonalEvent';
import { useHawkWidgetContext } from '../../HawkWidget/HawkWidgetContext';
import { TargetEnum } from '../../TrackedLink/model';

import styles from './styles/seasonal-event-merchant.css';

interface SeasonalEventMerchantComponentProps {
  merchant: SeasonalEventMerchant;
  className?: string;
}

const SeasonalEventMerchantComponent: React.FC<SeasonalEventMerchantComponentProps> = ({
  merchant,
  className,
}): JSX.Element => {
  const linkRef = React.useRef<HTMLAnchorElement | null>(null);
  const {
    site,
    area,
    trackingArea,
    articleName,
    articleUrl,
    sendAnalytics,
    genericSharedComponents: { LazyImage, TrackedLink },
    social,
  } = useHawkWidgetContext();

  const getLink = (customTrackingId: string): string =>
    getRewrittenUrl({
      url: merchant.merchant_url,
      site,
      customTrackingId,
      area,
      trackingArea,
      articleUrl,
      articleName,
      social,
    });

  const trackLinkClick = (): void => {
    sendAnalytics({
      affiliate: {
        action: {
          type: ActionType.SEASONAL_EVENT_RETAILER,
          event: LegacyActionEvent.CLICK_FROM,
        },
        component: {
          label: merchant.merchant_name,
        },
      },
      product: {
        product: {
          primary: {
            link: getLink(merchant.customTrackingId ?? ''),
            revenueId: merchant.customTrackingId,
          },
        },
        merchant: {
          id: merchant.merchant_id,
          name: merchant.merchant_name,
          url: merchant.merchant_url,
        },
      },
    });
  };

  const containerStyle = className && styles[className] ? className : 'container';

  return (
    <div className={styles[containerStyle]}>
      <TrackedLink
        trackLinkClick={trackLinkClick}
        customTarget={TargetEnum.BLANK}
        attributes={{
          ref: linkRef,
          className: styles['link'],
          href: getLink(merchant.customTrackingId ?? ''),
        }}
      >
        <div className={styles['image-container']}>
          <LazyImage src={merchant.logo} alt={merchant.merchant_name} width={100} height={50} />
        </div>
      </TrackedLink>
    </div>
  );
};

export default SeasonalEventMerchantComponent;
